import React__default from 'react';
import { useIntl, useSelector, statusUninit, statusLoading, statusWarning, statusFailed } from '@grandvisionhq/state';
import { useUpload } from '@grandvisionhq/upload';
import { useRxGlassesConfiguratorContext } from '../../Context/RxGlassesConfiguratorContext.js';
import { PrescriptionUploadStep } from './PrescriptionUploadStep.js';
import { getSelectedFrame, getPrescription, getIsPrescriptionStepValid } from '../../../state/configurator/selectors.js';
import { PRESCRIPTION_STEP_UPLOAD_ERROR_ID } from '../../../state/constants.js';

const PrescriptionUploadStepContainer = ()=>{
    const { hasLabel , getLabel  } = useIntl();
    const [errorMessageKey, setErrorMessageKey] = React__default.useState();
    const { configuratorDocument  } = useRxGlassesConfiguratorContext();
    const { prescriptionUploadStep  } = configuratorDocument || {};
    const frame = useSelector(getSelectedFrame);
    const prescription = useSelector(getPrescription);
    const isPrescriptionStepValid = useSelector(getIsPrescriptionStepValid);
    const { error  } = useUpload();
    const alertLabelKey = 'products.glasses.prescriptionFileRadio.alert';
    React__default.useEffect(()=>{
        if (isPrescriptionStepValid) {
            setErrorMessageKey(null);
            return;
        }
        setErrorMessageKey(error);
    }, [
        error,
        isPrescriptionStepValid
    ]);
    const isLoading = !prescription || statusUninit(prescription) || statusLoading(prescription);
    const isFailed = !frame || statusWarning(prescription) || statusFailed(prescription);
    return /*#__PURE__*/ React__default.createElement(PrescriptionUploadStep, {
        description: prescriptionUploadStep === null || prescriptionUploadStep === void 0 ? void 0 : prescriptionUploadStep.description,
        image: prescriptionUploadStep === null || prescriptionUploadStep === void 0 ? void 0 : prescriptionUploadStep.image,
        isLoading: isLoading,
        isFailed: isFailed,
        errorMessage: errorMessageKey ? getLabel(errorMessageKey) : '',
        errorMessageId: PRESCRIPTION_STEP_UPLOAD_ERROR_ID,
        alertLabel: hasLabel(alertLabelKey) ? getLabel(alertLabelKey) : ''
    });
};

export { PrescriptionUploadStepContainer };
//# sourceMappingURL=PrescriptionUploadStepContainer.js.map
